"use client"

// src/components/container.ts
var Container = {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    gap: { base: "lg", sm: "md" },
    p: { base: "lg", sm: "md" },
    w: "100%"
  }
};

export {
  Container
};
//# sourceMappingURL=chunk-FUSJGLKP.mjs.map